var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"map_container",attrs:{"id":"map_container"}},[_c('infoWindow',{attrs:{"show":_vm.showWindow,"infoObj":{}},on:{"update:show":function($event){_vm.showWindow=$event},"closeWindow":_vm.closeWindow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }